import { CSSProperties, useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { Close } from '../../../svg/Closes';

export const CloseModal = ({
  onClose,
  className,
  style
}: {
  onClose?: () => void;
  className?: string;
  style?: CSSProperties;
}) => {
  return (
    <Close onClick={onClose} className={twMerge('z-10 cursor-pointer', className)} style={style} />
  );
};

// const PAD_TOP = 25;
// const PAD_LEFT = 28;

export function useCrossPosition() {
  const modalContentRef = useRef<HTMLDivElement>(null);

  // const getCrossPosition = () => {
  //   const crossTop = Math.max((modalContentRef?.current?.offsetTop || 0) - PAD_TOP, 5);
  //   const crossLeft = Math.min(
  //     (modalContentRef?.current?.offsetLeft || 0) + (modalContentRef?.current?.offsetWidth || 0),
  //     window.innerWidth - PAD_LEFT
  //   );

  //   return {
  //     top: crossTop,
  //     left: crossLeft
  //   };
  // };

  // const [crossPosition, setCrossPosition] = useState(() => getCrossPosition());

  // const updateCrossPosition = useCallback(() => {
  //   const result = getCrossPosition();
  //   setCrossPosition(result);
  // }, []);

  // useEffect(() => {
  //   if (!modalContentRef.current) return;

  //   const observer = new ResizeObserver(() => {
  //     updateCrossPosition();
  //   });

  //   observer.observe(modalContentRef.current);
  //   return () => {
  //     observer.disconnect();
  //   };
  // }, []);

  return {
    // crossStyle: crossPosition,
    crossStyle: {
      top: 10,
      right: 10
    },
    modalContentRef
  };
}
